import * as React from 'react';
import PromoSlideForm from "../../components/Slides/PromoSlideForm/PromoSlideForm";
var PromoSlide = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0441\u043B\u0430\u0439\u0434"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(PromoSlideForm, null))))));
};
export default PromoSlide;



//////////////////
// WEBPACK FOOTER
// ./src/views/PromoSlides/PromoSlide.tsx
// module id = 416
// module chunks = 0